import { Button } from "@chakra-ui/button";
import { Menu, MenuButton, MenuList } from "@chakra-ui/react";
import { RiArrowDownSLine, RiCheckLine, RiDraftLine } from "react-icons/ri";
import { MenuItemWithDescription } from "src/components/Menus/MenuItemWithDescription";
import { useFlags } from "src/components/Providers/FeatureFlagProvider";
import * as GQL from "src/types/graphql";

type Props = {
  onPublish: () => Promise<void>;
  isDisabled?: boolean;
  mode: GQL.form_template_mode_enum;
};
export const ModeMenu: React.FC<Props> = ({
  onPublish,
  mode,
  isDisabled = false,
}) => {
  const flags = useFlags(["form-builder-draft-mode"]);
  return (
    <>
      {flags["form-builder-draft-mode"].enabled ? (
        <Menu>
          <MenuButton
            isDisabled={isDisabled}
            as={Button}
            leftIcon={
              mode === GQL.form_template_mode_enum.Draft ? (
                <RiDraftLine />
              ) : (
                <RiCheckLine />
              )
            }
            rightIcon={<RiArrowDownSLine />}
            variant="outline"
            colorScheme="gray"
          >
            {mode}
          </MenuButton>
          <MenuList>
            <MenuItemWithDescription
              title={GQL.form_template_mode_enum.Draft}
              description="Create and modify the form freely"
            />
            <MenuItemWithDescription
              onClick={onPublish}
              title={GQL.form_template_mode_enum.Published}
              description="Final form in use, limited editability"
            ></MenuItemWithDescription>
          </MenuList>
        </Menu>
      ) : null}
    </>
  );
};
